import React from 'react'
import { graphql, gql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import { translate } from 'react-i18next'

import { Form, SelectInput } from '../../UI'
import Loader from '../../UI/Loader'

import { ALL_LANGUAGES } from '../../../constants'
import { validateRequired } from '../../../libs/validation'
import { NotificationManager } from 'react-notifications'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class LanguagesForm extends React.Component {
  state = {
    saving: false,
    items: [
      {
        id: _.uniqueId(),
        language: null
      }
    ],
    error: '',
    routeIndex: 4
  }

  componentWillMount() {
    const languages = _.get(this, 'props.data.User.plannerProfile.languages', [])
    if (languages && languages.length) {
      const items = languages.map(language => {
        return {
          id: _.uniqueId(),
          language
        }
      })
      this.setState({ items })
    }
  }

  componentWillReceiveProps(nextProps) {
    const languages = _.get(this, 'props.data.User.plannerProfile.languages', [])
    const languagesNext = _.get(nextProps, 'data.User.plannerProfile.languages', [])
    if (languages && languagesNext && languages.length !== languagesNext.length) {
      const items = languagesNext.map(language => {
        return {
          id: _.uniqueId(),
          language
        }
      })
      this.setState({ items })
    }
  }

  getLanguageOptions = () => {
    let options = ALL_LANGUAGES.map(e => {
      return {
        label: e['name'],
        value: e['1']
      }
    })
    return options
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true,
      error: ''
    })
    const languages = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'language_') {
        if (languages.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: 'Each language must be chosen once'
          })
          return
        }
        languages.push(values[item])
      }
    }
    this.props
      .updatePlannerProfile({
        variables: {
          id: this.props.data.User.plannerProfile.id,
          languages
        }
      })
      .then(() => {
        this.props.data.refetch()
        NotificationManager.success('Languages updated', 'Success', 5000)
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.history.push('/create-guru-profile/guru-locations')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))

        NotificationManager.error('Error while updating languages', 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          language: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    console.log('props', this.props)
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('languages')}</div>
        <div className="steps-screen__form-subtitle">Defines the languages in which the plan is provided to your travelers.</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {this.state.items.map(el => {
                return (
                  <div key={el.id} className="removable-item-row">
                    <SelectInput
                      options={this.getLanguageOptions()}
                      id={`language_${el.id}`}
                      placeholder={t('select_language')}
                      initialValue={el.language}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                      isGroup={true}
                    />
                    {this.state.items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_language')} (optional)
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const updatePlannerProfile = gql`
  mutation($id: ID!, $languages: [String!]) {
    updatePlannerProfile(id: $id, languages: $languages) {
      id
    }
  }
`

const userQuery = gql`
  query userQuery {
    user {
      id
      plannerProfile {
        id
        languages
      }
    }
  }
`

const TranslatedLanguagesForm = translate('guru')(LanguagesForm)

export default graphql(updatePlannerProfile, {
  name: 'updatePlannerProfile'
})(
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })  
  (withRouter(TranslatedLanguagesForm))
)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/LanguagesForm.jsx